import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

type ApiHttpParams = HttpParams | Record<string, string | number | boolean | readonly (string | number | boolean)[]>

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private http = inject(HttpClient)

  get<T = any>(url: string, params?: ApiHttpParams): Observable<T> {
    return this.http.get<T>(this.prepareUrl(url), {
      params: params
    })
  }

  post<T = any, D = any>(url: string, data: D, params?: ApiHttpParams): Observable<T> {
    return this.http.post<T>(this.prepareUrl(url), data, {params})
  }

  private prepareUrl(url: string) {
    if (url.startsWith('https:') || url.startsWith('http:')) {
      return url
    }
    return environment.api.url.replace(/\/$/, '') + '/' + url.replace(/^\//, '')
  }

}
